import { Component, OnInit } from '@angular/core';
import { getSettingSelectors } from 'src/app/modules/settings/settings-general/store/setting.selector';
import { ISettingState } from 'src/app/modules/settings/settings-general/store/setting.state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  clientName: string = '';

  currentDay: Number;
  currentMonth: String;
  currentYear: Number;

  nameMonth: string[] = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingState;

  constructor(private store: Store) {
    this.currentDay = new Date().getDate();
    this.currentMonth = this.nameMonth[new Date().getMonth()];
    this.currentYear = new Date().getFullYear();
    this.clientName = getCookie('clientName');
  }

  ngOnInit(): void {
    this.getStateSetting();
  }

  getStateSetting() {
    this.dataStoreSetting$ = this.store.select(getSettingSelectors);
    this.dataStoreSetting$.subscribe((value) => {
      this.dataStoreSetting = {
        ...value,
        clientName: this.clientName
      };
    });
  }
}
